export function formatDetailDate(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);

  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function hasDetailValue(value) {
  if (value === null || value === undefined) return false;
  const text = String(value).replace(/<[^>]*>/g, "").replace(/&nbsp;/gi, " ").trim();
  return text.length > 0;
}

export function formatAnswerList(answers = []) {
  if (!Array.isArray(answers) || answers.length === 0) return "";

  return answers
    .map((answer, index) => {
      const en = answer?.answer_en || "";
      const mm = answer?.answer_mm || "";
      return `${index + 1}. ${en}\n   ${mm}`;
    })
    .join("\n\n");
}

export function dateInfoItems(record) {
  const items = [];
  const createdAt = record?.created_at || record?.createdAt;
  const updatedAt = record?.updated_at || record?.updatedAt;
  if (createdAt) {
    items.push({
      label: "Created Date",
      value: formatDetailDate(createdAt),
      icon: "calendar",
    });
  }
  if (updatedAt) {
    items.push({
      label: "Updated Date",
      value: formatDetailDate(updatedAt),
      icon: "calendar",
    });
  }
  return items;
}
